var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseIconGraySmall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.6095 10.5764C24.1302 10.0487 24.1302 9.19304 23.6095 8.66532C23.0888 8.1376 22.2446 8.1376 21.7239 8.66532L16 14.4664L10.2761 8.66532C9.75544 8.1376 8.91122 8.1376 8.39052 8.66532C7.86983 9.19304 7.86983 10.0487 8.39052 10.5764L14.1144 16.3774L8.39052 22.1785C7.86983 22.7062 7.86983 23.5618 8.39052 24.0895C8.91122 24.6173 9.75544 24.6173 10.2761 24.0895L16 18.2885L21.7239 24.0895C22.2446 24.6173 23.0888 24.6173 23.6095 24.0895C24.1302 23.5618 24.1302 22.7062 23.6095 22.1785L17.8856 16.3774L23.6095 10.5764Z",
    fill: "#969FA8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIconGraySmall);
export default __webpack_public_path__ + "static/media/close-icon-gray-small.0261e81fd584dc357ac3560ab6bf146c.svg";
export { ForwardRef as ReactComponent };